import { $host } from './index';
import { ENDPOINTS } from '../constants/endpoints';

export const getOrders = async () => {
  try {
    const { data } = await $host.get(ENDPOINTS.ORDERS.LIST);
    return data;
  } catch (error) {
    console.log(error);
    throw error?.response?.data;
  }
};

export const createOrder = async (paymentType) => {
  try {
    const { data } = await $host.post(ENDPOINTS.ORDERS.CREATE, paymentType);
    return data;
  } catch (error) {
    console.log(error);
    throw error?.response?.data;
  }
};

export const createBankOrder = async (orderData) => {
  try {
    const { data } = await $host.post(ENDPOINTS.ORDERS.CREATE, orderData);
    return data;
  } catch (error) {
    console.log(error);
    throw error?.response?.data;
  }
};

export const createTransaction = async (amount) => {
  try {
    const { data } = await $host.post(ENDPOINTS.ORDERS.CREATE_TRANSACTION, { amount });
    return data;
  } catch (error) {
    console.log(error);
    throw error?.response?.data;
  }
};

export const getPaymentFees = async () => {
  try {
    const { data } = await $host.get(ENDPOINTS.PAYMENT_FEES.LIST);
    return data;
  } catch (error) {
    console.log(error);
    throw error?.response?.data;
  }
};

export const getOrderById = async (id) => {
  try {
    const { data } = await $host.get(ENDPOINTS.ORDERS.INFO(id));
    return data;
  } catch (error) {
    console.log(error);
    throw error?.response?.data;
  }
};
